import React, { useEffect, useState } from 'react';
import { Dialog, Select, SelectTree, PopOver, OverlayTrigger } from '@tencent/spaui';
import _ from 'lodash';
import { Tags } from '../../../consts/Tags';
import { RPCFactory } from '../../../utils/RequestUtil';
import { uploadSteps } from './uploadSteps';
import { CorpSelector } from '../qw/corpSelector';
import { beaconInstance } from '../../../instrumentation/beaconSetup';
import { isQwAuthed } from '../../../utils/routes';

/**
 * 上报标签:
 * 1 FIRST_TALK: 开口咨询
 * 2 LEAVE_MESSAGE: 用户留资
 * 3 HIGH_INTENTION: 用户高意向
 * 4 ORDER: 用户下单
 * 5 INVALID: 无效用户
 * 6 VALID: 有效用户
 */
const ruleTypeMapping = {
  1: {
    title: '开口咨询',
    tips: '用户开口对话，用于优化用户开口率，会做优化目标',
  },
  2: {
    title: '用户留资',
    tips: '用户留了电话号码，用户优化用户留表单率，会做优化目标',
  },
  3: {
    title: '长期转化',
    tips: '用户深度后端行为，用于帮广告主找到最终目标受众（原“高意向”指标）',
  },
  4: {
    title: '付费',
    tips: '用户付费下单，用于优化用户下单率，是投放端深层优化目标之一',
  },
  5: {
    title: '无效用户',
    tips: '用户存在恶意行为等明确无意向行为，用于帮广告主减少恶意人群',
  },
  6: {
    title: '有效综合线索',
    tips: '初步判断该用户是符合营销目标的有效用户（如开口后确实有意向、留了电话回访后有意向等），用户优化用户有效开口率，是投放端深层优化目标之一',
  },
};

const ruleItemNameMapping = {
  followStatus: '跟进状态',
  tagId: '企微标签',
};
const ruleItemLabelValueMapping = Object.keys(ruleItemNameMapping).map((key, index) => ({
  label: ruleItemNameMapping[key],
  value: key,
}));
const qwFollowStatusDataCommon = [
  { value: 0, label: '待跟进' },
  { value: 2, label: '获得联系方式' },
  { value: 3, label: '有效客户' },
  { value: 14, label: '待下单' },
  { value: 12, label: '到店' },
  { value: 16, label: '成交' },
  { value: 1, label: '开口咨询' },
  { value: 15, label: '下订' },
  { value: 21, label: '无效客户' },
];
export const QwDataUpload = (props) => {
  const canEdit = isQwAuthed();
  const [editDialogVisible, setEditDialogVisible] = useState(false);
  const [editActionTypeItem, setEditActionTypeItem] = useState({});
  const [allRoles, setAllRoles] = useState([]); // useState(initSetting);
  const [tagGroups, setTagGroups] = useState([]); // 标签组树形结构数据
  const [qwFollowStatusData, setQwFollowStatusData] = useState([]);
  // const [followStatus, setFollowStatus] = useState([]); // 跟进状态
  const [ruleLabelValue, setRuleLabelValue] = useState(ruleItemLabelValueMapping); // 可选属性结构
  const updateMapping = () => {
    const mapping = Object.keys(ruleItemNameMapping).map((key, index) => ({
      label: ruleItemNameMapping[key],
      value: key,
      disabled:
        !!editActionTypeItem.applyRange &&
        (!!_.find(editActionTypeItem.applyRange.applyRangeDetail, { fieldName: key }) ||
          !!_.find(editActionTypeItem.applyRange.applyRangeDetail, { fieldScope: key })),
    }));
    setRuleLabelValue(mapping);
  };
  // 将标签后端返回的数据类型转为selectTree支持的类型
  const transformTagGroups = (tagGroupEntities) => {
    const tags = tagGroupEntities.map((tagGroupItem) => ({
      value: tagGroupItem.groupId,
      desc: tagGroupItem.groupName,
      options: tagGroupItem.tag.map((tagItem) => ({
        value: tagItem.id,
        desc: tagItem.name,
      })),
    }));
    setTagGroups(tags);
  };

  // 过滤掉已经删除的企微标签ID
  const filterTagIds = (ids) =>
    ids.filter((id) => {
      const matchGroupObj = _.find(tagGroups, { value: id });
      const tagItems = [];
      for (let index = 0; index < tagGroups.length; index++) {
        tagItems.push(...tagGroups[index].options);
      }
      const matchItemObj = _.find(tagItems, { value: id });
      if (matchGroupObj || matchItemObj) {
        return true;
      }
      return false;
    });
  const getQwDmpReport = () => {
    RPCFactory.dmpReport
      .getQwDmpReport({})
      .done((data) => {
        setAllRoles(data.entities);
      })
      .fail((ret, msg) => {
        alert(msg);
      });
    if (window.pageProps.corpId) {
      RPCFactory.qwSidebar
        .getTags()
        .done((data) => {
          transformTagGroups(data);
        })
        .fail((ret, msg) => {
          alert(msg);
        });
    }
  };
  useEffect(() => {
    getQwDmpReport();
  }, []);

  useEffect(() => {
    updateMapping();
  }, [editActionTypeItem]);

  useEffect(() => {
    beaconInstance.onUserAction(
      'page_view',
      { page: '企微上报' },
    );
  }, []);

  useEffect(() => {
    RPCFactory.qwCustomer
      .getFollowStatusList()
      .done((data = {}) => {
        const statusList = [];
        const list = data.followStatusGroupList || [];
        list.forEach((item) => {
          (item.followStatusList || []).forEach((child) => {
            statusList.push({
              value: child.code,
              label: child.desc,
            });
          });
        });
        setQwFollowStatusData(statusList);
      })
      .fail(() => {
        setQwFollowStatusData(qwFollowStatusDataCommon);
      });
  }, []);

  // 生成跟进记录字段
  const getFollowStatusDesc = (fieldValues) => {
    const nameArr = fieldValues.map((ele) => Tags.qwFollowStatus[ele]);
    return nameArr.join(', ');
  };

  // 生成标签字段
  const getTagsDesc = (fieldValues) => {
    const nameArr = [];
    fieldValues.forEach((tagId) => {
      tagGroups.forEach((tagGroup) => {
        tagGroup.options.forEach((ele) => {
          if (ele.value === tagId) {
            nameArr.push(ele.desc);
          }
        });
      });
    });
    return nameArr.join(', ');
  };

  const editRuleActionType = (item) => {
    setEditDialogVisible(true);
    setEditActionTypeItem(_.cloneDeep(item));
  };

  const closeEditDialog = () => {
    setEditDialogVisible(false);
  };

  const submitEditDialog = () => {
    const invalid = _.findIndex(editActionTypeItem.applyRange.applyRangeDetail, function (o) {
      return !o.fieldName || o.fieldValues.length == 0;
    });
    if (invalid > -1 && editActionTypeItem.applyRange.applyRangeDetail.length > 0) return;
    const dialogTitle = ruleTypeMapping[editActionTypeItem.wxWorkReportType].title;
    beaconInstance.onUserAction(
      'btn_click',
      { page: '企微上报', name: dialogTitle },
    );
    RPCFactory.dmpReport
      .setQwDmpReport(editActionTypeItem)
      .done((data) => {
        const index = _.findIndex(allRoles, { wxWorkReportType: editActionTypeItem.wxWorkReportType });
        const newAllRoles = _.cloneDeep(allRoles);
        newAllRoles[index] = editActionTypeItem;
        setAllRoles(newAllRoles);
        setEditDialogVisible(false);
      })
      .fail((ret, msg) => {
        alert(msg);
      });
  };

  const changeRuleItemName = (curIndex, newValue) => {
    const newEditItem = _.cloneDeep(editActionTypeItem);

    let index = _.findIndex(editActionTypeItem.applyRange.applyRangeDetail, { fieldName: newValue });
    if (index > -1) {
      newEditItem.applyRange.applyRangeDetail[index].fieldName = newValue;
    } else {
      index = _.findIndex(editActionTypeItem.applyRange.applyRangeDetail, { fieldScope: newValue });
    }
    _.remove(
      newEditItem.applyRange.applyRangeDetail,
      (item) => item.fieldName === newValue || item.fieldScope === newValue,
    );

    newEditItem.applyRange.applyRangeDetail[curIndex].fieldValues = [];
    newEditItem.applyRange.applyRangeDetail[curIndex].fieldName = newValue;
    newEditItem.applyRange.applyRangeDetail[curIndex].fieldScope = 'WXWORK_REPORT';
    setEditActionTypeItem(newEditItem);
  };

  const changeRuleItemValues = (curIndex, newValue) => {
    const newEditItem = _.cloneDeep(editActionTypeItem);
    newEditItem.applyRange.applyRangeDetail[curIndex].fieldValues = newValue;
    setEditActionTypeItem(newEditItem);
  };
  const deleteRuleItem = (index) => {
    const newEditItem = _.cloneDeep(editActionTypeItem);
    newEditItem.applyRange.applyRangeDetail.splice(index, 1);
    setEditActionTypeItem(newEditItem);
  };

  const addRuleItem = () => {
    const newEditItem = _.cloneDeep(editActionTypeItem);
    newEditItem.applyRange.applyRangeDetail.push({
      fieldScope: 'WXWORK_REPORT',
      fieldName: '',
      matchRelation: 'IN',
      fieldValues: [],
    });
    setEditActionTypeItem(newEditItem);
  };
  return (
    <main className="main" id="leads-data">
      <CorpSelector {...props} onChange={getQwDmpReport} />
      {uploadSteps()}
      <div className="card padding-normal">
        <div className="card-title-all">
          <span className="card-title">设置上报规则</span>
          {!canEdit && (
            <span className="could-not-edit" style={{ marginLeft: '15px', color: 'red' }}>
              暂不支持编辑自定义上报规则，请先前往企微运营模块授权企业微信。
            </span>
          )}
        </div>
        <ul className="custom-infolist">
          {allRoles.map((rules, index) => (
            <li className="item rule" key={allRoles[index].wxWorkReportType}>
              <div className="item-left rule-name" style={{ display: 'block' }}>
                <div className="help-tips">
                  <span>{ruleTypeMapping[allRoles[index].wxWorkReportType].title}</span>
                  <OverlayTrigger
                    placement="right"
                    trigger="hover"
                    delay={100}
                    overlay={(<PopOver>{ ruleTypeMapping[allRoles[index].wxWorkReportType].tips }</PopOver>)}
                  >
                    <i className="icon icon-help" style={{ marginLeft: 8 }} />
                  </OverlayTrigger>
                </div>
              </div>
              <div className="item-right rule-list">
                <div className="content">
                  {allRoles[index].applyRange &&
                    allRoles[index].applyRange.applyRangeDetail.map((item) =>
                      allRoles[index].applyRange.applyRangeDetail.length ? (
                        <div className="rule-item">
                          <span className="rule-key">{ruleItemNameMapping[item.fieldName]}</span>
                          <span> </span>
                          {item.fieldName === 'followStatus' && (
                            <span className="rule-values">{getFollowStatusDesc(item.fieldValues)}</span>
                          )}
                          {item.fieldName !== 'followStatus' && (
                            <span className="rule-values">{getTagsDesc(item.fieldValues)}</span>
                          )}
                        </div>
                      ) : null,
                    )}
                </div>
                {canEdit && (
                  <div className="action">
                    <a
                      aria-label="编辑"
                      className="editable-icon"
                      onClick={() => {
                        editRuleActionType(allRoles[index]);
                      }}
                    >
                      <i className="icon icon-pen"></i>
                    </a>
                  </div>
                )}
              </div>
            </li>
          ))}
        </ul>
        <Dialog
          backdrop
          show={editDialogVisible}
          type="normal"
          title={_.get(ruleTypeMapping, [editActionTypeItem.wxWorkReportType, 'title'])}
          className="customrule-dialog data-upload-rule-dialog"
          style={{ width: '918px' }}
          onClose={closeEditDialog}
          onCancel={closeEditDialog}
          onSubmit={submitEditDialog}
        >
          <div className="info-des-sec">
            <div className="config-li">
              <div className="con-setting">
                <span className="tt">条件关系：或</span>
              </div>
              {editActionTypeItem.applyRange &&
                editActionTypeItem.applyRange.applyRangeDetail.map((item, index) =>
                  editActionTypeItem.applyRange.applyRangeDetail ? (
                    <div className="form-in">
                      <div className={!item.fieldName ? 'has-error' : ''}>
                        <Select
                          className="filter-key"
                          data={ruleLabelValue}
                          value={item.fieldName}
                          style={{ width: 300 }}
                          onChange={(e, _value) => {
                            changeRuleItemName(index, _value);
                          }}
                          status={!item.fieldName ? 'has-error' : ''}
                        />
                      </div>
                      <div style={{ width: '64px', 'padding-left': '15px', 'margin-top': '8px' }}>包括</div>
                      {
                        // 企微标签
                        item.fieldName === 'tagId' && (
                          <div className={item.fieldValues.length === 0 ? 'has-error' : ''}>
                            <SelectTree
                              className="filter-values"
                              value={filterTagIds(item.fieldValues)}
                              data={tagGroups}
                              multiple={true}
                              valueType="child"
                              dropStyle={{ width: 600 }}
                              style={{
                                width: '300px',
                              }}
                              onChange={(e, value) => {
                                changeRuleItemValues(index, value);
                              }}
                              status={item.fieldValues.length === 0 ? 'has-error' : ''}
                            />
                          </div>
                        )
                      }
                      {
                        // 普通下拉框类型
                        item.fieldName !== 'tagId' && (
                          <div className={item.fieldValues.length === 0 ? 'has-error' : ''}>
                            <Select
                              className="filter-values"
                              multiple
                              data={qwFollowStatusData}
                              value={item.fieldValues}
                              style={{ width: 300 }}
                              onChange={(e, _value) => {
                                changeRuleItemValues(index, _value);
                              }}
                            />
                          </div>
                        )
                      }
                      {
                        <div className="close-wraper">
                          <i
                            className="icon icon-close"
                            onClick={(e) => {
                              deleteRuleItem(index);
                            }}
                          ></i>
                        </div>
                      }
                    </div>
                  ) : null,
                )}
              <a
                className="edit"
                onClick={() => {
                  addRuleItem();
                }}
              >
                ＋添加条件
              </a>
            </div>
          </div>
        </Dialog>
      </div>
    </main>
  );
};
